import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  CardContent,
  Typography,
  IconButton,
  TextField,
  Button,
  styled,
  FormControl,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import axios from "axios";
import { API_BASE_URL } from "../../../apiConfig";
import ArticleEditor from "./ArticleEditor";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import LinkIcon from "@mui/icons-material/Link";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DescriptionIcon from "@mui/icons-material/Description";
import { refreshTokenIfNeeded } from "../refreshTokenIfNeeded";
import { useNavigate } from "react-router-dom";

const StyledCard = styled(Box)(({ theme }) => ({
  // تصميم خاص
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  height: "90%",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

function EditStore({ storeId, onClose, onSubmit }) {
  const [isLoading, setIsLoading] = useState(false);
  const [storeData, setStoreData] = useState({
    storeTitle: "",
    storeDescription: "",
    slug: "",
    storesImagePath: "",
    storeName: "",
    metaDescription: "",
  });
  const navigate = useNavigate();

  const [imageFile, setImageFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    const fetchCarData = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
          `${API_BASE_URL}Store/Find/${storeId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setStoreData(response.data);
        setStoreData({
          storeTitle: response.data.storeTitle || "",
          storeDescription: response.data.storeDescription || "",
          slug: response.data.slug || "",
          storesImagePath: response.data.storesImagePath || "",
          storeName: response.data.storeName || "",
          metaDescription: response.data.metaDescription || "",
        });

        setImageFile(response.data.storesImagePath);
        setPreviewImage(response.data.storesImagePath);
      } catch (error) {
        if (error.response?.status === 401) {
          try {
            const newToken = await refreshTokenIfNeeded();

            if (!newToken) {
              return navigate("/", { replace: true });
            }

            // إعادة الطلب بالتوكن الجديد
            const response = await axios.get(
              `${API_BASE_URL}Store/Find/${storeId}`,
              {
                headers: {
                  Authorization: `Bearer ${newToken}`,
                },
              },
            );

            setStoreData(response.data);
            setStoreData({
              storeTitle: response.data.storeTitle || "",
              storeDescription: response.data.storeDescription || "",
              slug: response.data.slug || "",
              storesImagePath: response.data.storesImagePath || "",
              storeName: response.data.storeName || "",
              metaDescription: response.data.metaDescription || "",
            });

            setImageFile(response.data.storesImagePath);
            setPreviewImage(response.data.storesImagePath);
          } catch (retryError) {
            alert("Retry failed: " + retryError.message);
          }
        } else {
          alert("Failed to load car data.");
        }
      }
    };

    fetchCarData();
  }, [storeId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setStoreData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => {
        setStoreData((prevData) => ({
          ...prevData,
          storesImagePath: reader.result,
        }));
      };
      reader.readAsDataURL(file);
      setImageFile(file);
    } else {
      console.error("الملف غير صالح");
    }
    e.target.value = "";
  };

  const handleRemoveImage = () => {
    setStoreData((prevData) => ({
      ...prevData,
      storesImagePath: "",
    }));
    setImageFile(null);
  };

  const handleDescriptionChange = (value) => {
    setStoreData((prevData) => ({
      ...prevData,
      storeDescription: value,
    }));
  };

  const handleSubmit = async () => {
    if (
      !storeData.storeTitle ||
      !storeData.storeDescription ||
      !storeData.slug ||
      !storeData.storeName ||
      !storeData.metaDescription ||
      !imageFile
    ) {
      alert("يرجى ملء جميع الحقول.");
      return;
    }

    const token = localStorage.getItem("token");

    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("storeTitle", storeData.storeTitle);
      formData.append("storeDescription", storeData.storeDescription);
      formData.append("slug", storeData.slug);
      formData.append("storesImagePath", storeData.storesImagePath);
      formData.append("storeName", storeData.storeName);
      formData.append("metaDescription", storeData.metaDescription);

      if (imageFile) {
        formData.append("imageFile", imageFile);
      } else {
        formData.append("imageFile", previewImage);
      }

      await axios.put(`${API_BASE_URL}Store/Update/${storeId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      alert("تم تعديل المتجر بنجاح");
      setIsLoading(false);
      onSubmit();
      onClose();
    } catch (error) {
      if (error.response?.status === 401) {
        try {
          const newToken = await refreshTokenIfNeeded();

          if (!newToken) {
            return navigate("/", { replace: true });
          }

          // إعادة الطلب بالتوكن الجديد
          const retryFormData = new FormData();
          retryFormData.append("storeTitle", storeData.storeTitle);
          retryFormData.append("storeDescription", storeData.storeDescription);
          retryFormData.append("slug", storeData.slug);
          retryFormData.append("storesImagePath", storeData.storesImagePath);
          retryFormData.append("storeName", storeData.storeName);
          retryFormData.append("metaDescription", storeData.metaDescription);

          if (imageFile) {
            retryFormData.append("imageFile", imageFile);
          } else {
            retryFormData.append("imageFile", previewImage);
          }

          await axios.put(
            `${API_BASE_URL}Store/Update/${storeId}`,
            retryFormData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${newToken}`,
              },
            },
          );

          alert("تم تعديل المتجر بنجاح");
          setIsLoading(false);
          onSubmit();
          onClose();
        } catch (retryError) {
          alert("Retry failed: " + retryError.message);
        }
      } else {
        setIsLoading(false);
        alert(
          "Error updating store: " + (error.response?.data || error.message),
        );
      }
    }
  };

  if (isLoading) {
    return <div>..جاري التحميل</div>;
  }

  return (
    <Modal
      dir="rtl"
      open={true}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <StyledCard>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 0 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                fontFamily: "'Changa', sans-serif",
              }}
            >
              <h3>تعديل متجر</h3>
            </div>
          </Box>
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", top: 16, right: 16 }}
          >
            <CloseIcon />
          </IconButton>

          {/* تصميم العرض الجانبي للصورة والحقول */}
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            {/* الصورة على اليسار */}
            <Box
              sx={{
                width: "40%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* عرض الصورة أو النص الافتراضي */}
              <Box
                sx={{
                  width: 300,
                  height: 180,
                  marginTop: 2,
                  border: "1px solid #ccc",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#f5f5f5",
                  textAlign: "center",
                  borderRadius: 2,
                }}
              >
                {storeData.storesImagePath ? (
                  <img
                    src={storeData.storesImagePath}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <Typography variant="body2">لا توجد صورة</Typography>
                )}
              </Box>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "3%",
                  gap: "10px",
                }}
              >
                <Button variant="contained" component="label">
                  تحميل صورة
                  <input type="file" hidden onChange={handleFileChange} />
                </Button>

                {/* زر إزالة الصورة */}
                {storeData.storesImagePath && (
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleRemoveImage} // استدعاء دالة إزالة الصورة هنا
                    //sx={{ mt: 2 }}
                  >
                    إزالة الصورة
                  </Button>
                )}
              </div>
            </Box>

            {/* الحقول على اليمين */}
            <Box sx={{ width: "65%" }}>
              <CardContent sx={{ textAlign: "right", mt: -5 }}>
                {/* حقول الإدخال */}
                <FormControl fullWidth sx={{ marginBottom: 1 }}>
                  <TextField
                    placeholder="عنوان المتجر"
                    value={storeData.storeTitle}
                    name="storeTitle"
                    onChange={handleChange}
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LocalGroceryStoreIcon sx={{ color: "#1976d2" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>

                <FormControl fullWidth sx={{ marginBottom: 1 }}>
                  <TextField
                    placeholder="رابط المتجر"
                    value={storeData.slug}
                    disabled
                    name="slug"
                    onChange={handleChange}
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LinkIcon sx={{ color: "#1976d2" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>

                <FormControl fullWidth sx={{ marginBottom: 1 }}>
                  <TextField
                    placeholder="اسم المتجر"
                    value={storeData.storeName}
                    name="storeName"
                    onChange={handleChange}
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <DriveFileRenameOutlineIcon
                            sx={{ color: "#1976d2" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>

                <FormControl fullWidth sx={{ marginBottom: 1 }}>
                  <TextField
                    placeholder="وصف الميتا المتجر"
                    value={storeData.metaDescription}
                    name="metaDescription"
                    onChange={handleChange}
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <DescriptionIcon sx={{ color: "#1976d2" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>

                {/* محرر النصوص للوصف */}
                <FormControl fullWidth sx={{ marginBottom: 1 }}>
                  <ArticleEditor
                    value={storeData.storeDescription}
                    onChange={handleDescriptionChange}
                  />
                </FormControl>
              </CardContent>
            </Box>
          </Box>

          <Box sx={{ textAlign: "center", mt: 2 }}>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              حفظ التعديلات
            </Button>
          </Box>
        </StyledCard>
      </Box>
    </Modal>
  );
}

export default EditStore;
